//----------------------------------------------------------------------------------------------------------------------
// Visible Property Handler
//----------------------------------------------------------------------------------------------------------------------

import { AbstractMesh, type TransformNode } from '@babylonjs/core';
import type { LevelManager } from '../managers/level.ts';

//----------------------------------------------------------------------------------------------------------------------

/**
 * Register the visible property handler.
 *
 * Supports the following property on scene nodes:
 * - `visible` (boolean | string | number): Controls mesh visibility.
 *   Accepts true/false, 'true'/'false', or 1/0.
 *
 * @param levelManager
 */
export function registerVisibleHandler(levelManager : LevelManager) : void
{
    levelManager.registerPropertyHandler('visible', (node : TransformNode, value : unknown, _level, _gameEngine) =>
    {
        // Only meshes have isVisible property
        if(!(node instanceof AbstractMesh))
        {
            return;
        }

        // Parse value as boolean
        // Supports: true/false (boolean), 'true'/'false' (string), 1/0 (number)
        let visible = true;

        if(typeof value === 'boolean')
        {
            visible = value;
        }
        else if(typeof value === 'string')
        {
            visible = value.toLowerCase() === 'true' || value === '1';
        }
        else if(typeof value === 'number')
        {
            visible = value !== 0;
        }

        node.isVisible = visible;
    });
}

//----------------------------------------------------------------------------------------------------------------------
